import React, { Component } from 'react';

class FeedbackSet extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default FeedbackSet;